import React from 'react'

import CommentView from '../components/CommentView'
import { HistoryScreenNavigationProp } from '../types'

export default function HistoryScreen({ route }: HistoryScreenNavigationProp) {
  return <CommentView bill={route.params.bill} />
}
